import React, { useState } from "react";
import "./App.css";
import { Board } from "./components/Board";
import { GameSetup } from "./components/GameSetup";
import { TileSetMap } from "./constants";

function getTilesFromParams() {
  if (window.location.search) {
    const parts = window.location.search.substring(1).split("=");
    if (parts[1]) {
      return parts[1].replaceAll("%20", " ").split(',');
    }
  }
  return null;
}

function App() {
  const [choices, setChoices] = useState(getTilesFromParams() || TileSetMap['all-hands']);
  const [includeFreeTile, setIncludeFreeTile] = useState(true);
  const [showSetup, setShowSetup] = useState(false);

  const prepareChoices = () => {
    let preparedChoices = [];
    while (preparedChoices.length < 25) {
      preparedChoices = preparedChoices.concat(choices);
    }
    return preparedChoices.slice(0, 25).sort(() => 0.5 - Math.random());
  };

  return (
    <div className="app">
      <header className="app-header">
        <h1>Clear Bingo</h1>
        <p>
          Looking to spice up a meeting, show, or activity? Try adding a custom
          bingo game! Select a preset of tiles or enter your own list of tiles.
        </p>
      </header>
      <button onClick={() => setShowSetup(!showSetup)}>
        {showSetup ? "Close" : "Setup Game First!"}
      </button>
      {showSetup ? (
        <GameSetup
          onSubmit={(v) => {
            window.location.search = 'tiles=' + v.join(',');
            setChoices(v);
          }}
          includeFreeTile={includeFreeTile}
          setIncludeFreeTile={setIncludeFreeTile}
        />
      ) : (
        <Board choices={prepareChoices()} includeFreeTile={includeFreeTile} />
      )}
    </div>
  );
}

export default App;
